import { SERVICES } from "@/lib/site";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import ServiceCard from "@/components/ServiceCard";
import CallStrip from "@/components/CallStrip";

const SITE_URL =
  (typeof window !== "undefined" && window.location.origin) ||
  "https://flowgridplumbing.com.au";

export default function ServicesPage() {
  return (
    <>
      <SEO
        title="Plumbing Services — Hot Water, Gas, Leaks, Jet Blasting"
        description="Full plumbing services across Sydney Metro — emergency plumbing, hot water systems, gas fitting, leak detection, jet blasting and appliance installation. Licensed, insured, 24/7."
        canonicalPath="/services"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListElement: SERVICES.map((s, i) => ({
            "@type": "ListItem",
            position: i + 1,
            url: `${SITE_URL}/services/${s.slug}`,
            name: s.title,
          })),
        }}
      />
      <PageHeader
        eyebrow="Services"
        title="Plumbing services across Sydney Metro."
        subtitle="From a leaky tap to a 2am burst main — one local crew, all the trades, all in one phone call."
      />

      <section className="bg-slate-900 py-20 md:py-24" data-testid="services-grid-section">
        <div className="fg-container">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s) => (
              <ServiceCard key={s.slug} service={s} />
            ))}
          </div>
        </div>
      </section>

      <CallStrip />
    </>
  );
}
